import { useNavigate } from 'react-router';

import { getApplicationEventProperties } from '~domains/partner-application/shared/lib';
import { StatusScreenContent } from '~domains/partner-application/shared/ui/status-screen-content';

import { ampli } from '~shared/analytics';
import { ROUTES } from '~shared/config/routes';
import { Screen } from '~shared/ui/screen';

import { ButterflyMoney as ButterflyMoneyIllustration } from '@breezeventures/ui-kit/next/illustrations/medium/butterfly-money';

import { PartnerApplicationMenuHeader } from '../../partner-application-menu-header';

type NewApplicationScreenProps = {
  applicationId: string;
};

export const NewApplicationScreen = ({
  applicationId,
}: NewApplicationScreenProps) => {
  const navigate = useNavigate();

  return (
    <Screen header={<PartnerApplicationMenuHeader />}>
      <StatusScreenContent
        icon={<ButterflyMoneyIllustration alt="" />}
        title={<>You&#39;re almost done, boss!</>}
        description={
          <>
            Share the&nbsp;other&nbsp;details to&nbsp;complete
            your&nbsp;application.
          </>
        }
        action={{
          label: 'Finish application',
          onClick: () => {
            ampli.mpPaFinishApplicationClick(
              getApplicationEventProperties(applicationId)
            );
            navigate(ROUTES.partner.applicationEdit.link(applicationId));
          },
        }}
      />
    </Screen>
  );
};
